import { setUserId } from "@amplitude/analytics-browser";

export const setAmplitudeUser = (userId: string) => {
  setUserId(userId);
};
